import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/modal';
import ResearchPropertySelector from 'components/research_property/research_property_select';
import { Button } from 'react-bootstrap-5';

export default function ResearchPropertyModal({ show, onConnect, onHide }) {
  const [connecting, setConnecting] = useState(false);
  const [property, setProperty] = useState(null);
  const handleConnect = async () => {
    setConnecting(true);
    await onConnect(property.value);
    setConnecting(false);
    onHide();
  };

  return (
    <Modal
      className="overflow-visible"
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        Connect Property
      </Modal.Header>
      <Modal.Body>
        <label className="mb-1 form-label">Search Properties</label>
        <ResearchPropertySelector placeholder="Search name or address" onModelAdded={setProperty} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="ghost" onClick={onHide}>Cancel</Button>
        <Button disabled={!property || connecting} onClick={handleConnect}>Connect</Button>
      </Modal.Footer>
    </Modal>
  );
}

ResearchPropertyModal.propTypes = {
  show: PropTypes.bool,
  onConnect: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};
